import React from "react";
import ClinicalInfoPage from "./ClinicalInfoPage";
import { DischargedProvider } from "../context/DischargedContext";
import { AdmittedProvider } from "../context/AdmittedContext";
import { EmergencyProvider } from "../context/EmergencyContext";
import { HighCostProvider } from "../context/HighCostContext";
import { HighRiskProvider } from "../context/HighRiskContext";

/**
 * Container component that wraps ClinicalInfoPage with all required context providers.
 * This encapsulates the clinical-info module's state management within the module itself.
 */
const ClinicalInfoPageContainer = () => {
  return (
    <DischargedProvider>
      <AdmittedProvider>
        <EmergencyProvider>
          <HighCostProvider>
            <HighRiskProvider>
              <ClinicalInfoPage />
            </HighRiskProvider>
          </HighCostProvider>
        </EmergencyProvider>
      </AdmittedProvider>
    </DischargedProvider>
  );
};

export default ClinicalInfoPageContainer;
